import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_2 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_3 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_aside_mobile_toggle"
}
const _hoisted_4 = { class: "svg-icon svg-icon-2x mt-1" }
const _hoisted_5 = { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0" }
const _hoisted_6 = {
  href: "#",
  class: "d-lg-none"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1" }
const _hoisted_9 = {
  class: "d-flex align-items-center",
  id: "kt_header_nav"
}
const _hoisted_10 = {
  "data-kt-swapper": "true",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_content_container', 'lg': '#kt_header_nav'}",
  class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
}
const _hoisted_11 = { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-1" }
const _hoisted_12 = {
  key: 0,
  class: "h-20px border-gray-200 border-start mx-4"
}
const _hoisted_13 = {
  key: 1,
  class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1"
}
const _hoisted_14 = { class: "breadcrumb-item pe-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_16 = {
  key: 0,
  class: "breadcrumb-item text-muted"
}
const _hoisted_17 = {
  key: 1,
  class: "breadcrumb-item pe-3"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bg-gray-200 w-5px h-2px" })
], -1)
const _hoisted_19 = { class: "breadcrumb-item pe-3 text-dark" }
const _hoisted_20 = {
  key: 0,
  class: "page-title d-flex align-items-center mb-5 mb-lg-0"
}
const _hoisted_21 = { class: "d-flex align-items-center text-dark my-1 fs-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_23 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-6 my-1" }
const _hoisted_24 = { class: "breadcrumb-item text-muted" }
const _hoisted_25 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KTTopbar = _resolveComponent("KTTopbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }, "d-flex align-items-stretch justify-content-between"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs015.svg" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", _hoisted_6, [
          _createElementVNode("img", {
            alt: "Logo",
            src: _ctx.themeLogoIcon,
            class: "h-30px"
          }, null, 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.I18nUtils.translate(_ctx.pageTitle)), 1),
            (_ctx.breadcrumbs)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.breadcrumbs)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/dashboard",
                      class: "text-muted text-hover-primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.home.title")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_15,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (!_ctx.getBreadcrumbRoute(index))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(_ctx.I18nUtils.translate(item)), 1))
                        : (_openBlock(), _createElementBlock("li", _hoisted_17, [
                            _createVNode(_component_router_link, {
                              to: _ctx.getBreadcrumbRoute(index),
                              class: "text-muted text-hover-primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate(item)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])),
                      _hoisted_18
                    ], 64))
                  }), 128)),
                  _createElementVNode("li", _hoisted_19, _toDisplayString(_ctx.I18nUtils.translate(_ctx.title)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.themeName), 1),
              _hoisted_22,
              _createElementVNode("ul", _hoisted_23, [
                _createElementVNode("li", _hoisted_24, _toDisplayString(_ctx.I18nUtils.translate(_ctx.title)), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ]))
}